// Ported from qr-phone-frontend src/app/utils/globals.ts (v3.2.0.0).
// Shared mutable state read by the signaling core outside the React render cycle.
import { backendLanguageCode } from '../i18n'

export const globals: any = {
  socket: null,
  user_id: null,
  email: null,
  userData: null,
  authToken: null, // staff softphone JWT (roadmap #41); the guest caller stays anonymous
  language_id: backendLanguageCode, // backend message language (see src/i18n); 1 = en, 3 = es
  device_id: null,
  logList: [],
  currentScreenName: null,
  request_from: 'web',

  // CALLER DETAIL
  hasAnswered: false,
  callerSocketID: null,
  callerUserName: null,
  callStartTime: null,
  call_id: null,
  isThisDefaultStaffNotified: false,
  maxResponseSeconds: 45,
  callStaffData: null,
  enabledDirectCall: 0,
  callerDetail: {},
  userFromNotification: false,
  notification_received_time: null,
  peerConnection: null,
  localUser: {},
  remoteUsers: {},
  isCallActive: false,
  activeCallId: 0,
  activeCallStatus: null,
  remoteStreams: null,
  localStreams: null,
  appVersion: 0.72,
  hasUserInteractedWithDocument: false,
  iceServers: null,
}
